import React, { useEffect, useState } from "react";
import { Nav } from "react-bootstrap";
import { NavLink, useNavigate } from "react-router-dom";
import { useUserContext } from "../../../utils/hooks/UserContext";
import io from "socket.io-client";
import { socket_url } from "../../../utils/api/axios";
import { VscDebugBreakpointUnsupported } from "react-icons/vsc";

import Modal from "react-awesome-modal";

function UserSideMenuComponent() {
  const user = useUserContext();
  const [socket, setSocket] = useState(null);
  const [count, setCount] = useState(0);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const socket = io(socket_url);
    setSocket(socket);
    socket.on("connect", () => {
      console.log(socket.connected);
    });

    socket.on("notification_count", (data) => {
      console.log(data);
      setCount(data.allUnSeenMessage.length);
    });
    socket.emit("message_notification", {
      id: user?.user?.user_id,
      userType: user?.user?.userType,
    });
  }, []);

  const { handleLogout } = useUserContext();
  const navigate = useNavigate();

  const onClickLogOutConfirmationPopup = () => {
    console.log("33333333");
    setVisible(true);
  };
  const onClickLogOut = () => {
    handleLogout();
    navigate("/");
  };

  return (
    <>
      <Nav className="flex-column user_dash_nav">
        {/* <Nav.Item>
          <NavLink to="/user/dashboard" className="nav-link">
            <span className="user_nav_link_icon">
              <svg
                width="29"
                height="27"
                viewBox="0 0 29 27"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M28.7584 13.0742C28.3 9.54551 26.5152 6.32378 23.7667 4.06384C21.0181 1.8039 17.5122 0.675339 13.9615 0.907549C10.4107 1.13976 7.08162 2.71531 4.65084 5.31397C2.22006 7.91262 0.870006 11.3394 0.875086 14.8977C0.868361 16.8023 1.25432 18.6878 2.00887 20.4366C2.76342 22.1854 3.87036 23.7598 5.26059 25.0617C6.32382 26.0461 7.72477 26.5841 9.17359 26.5644H20.5684C22.099 26.568 23.5696 25.9691 24.6623 24.8972C26.2194 23.3822 27.4008 21.5241 28.112 19.4713C28.8232 17.4185 29.0446 15.2278 28.7584 13.0742ZM9.59242 22.6689C9.49119 22.784 9.36826 22.878 9.23067 22.9456C9.09307 23.0132 8.9435 23.053 8.79051 23.0628C8.63752 23.0725 8.48411 23.052 8.33905 23.0024C8.19399 22.9529 8.06011 22.8752 7.94509 22.7739C6.3416 21.3661 5.20548 19.5028 4.68827 17.4327C4.17105 15.3625 4.29733 13.1839 5.05026 11.1874C5.80319 9.19084 7.14697 7.47134 8.90236 6.25823C10.6578 5.04513 12.7413 4.39609 14.8751 4.39769C15.76 4.39796 16.6415 4.50888 17.4989 4.72786C17.6474 4.76616 17.7868 4.83333 17.9093 4.92553C18.0318 5.01773 18.135 5.13316 18.2129 5.26522C18.2908 5.39728 18.3419 5.54339 18.3633 5.6952C18.3847 5.84702 18.3761 6.00157 18.3378 6.15003C18.2995 6.29849 18.2323 6.43795 18.1401 6.56045C18.0479 6.68295 17.9325 6.78609 17.8004 6.86398C17.6683 6.94188 17.5222 6.993 17.3704 7.01442C17.2186 7.03585 17.064 7.02716 16.9156 6.98886C15.1382 6.52817 13.2573 6.68044 11.5772 7.42103C9.89701 8.16163 8.51575 9.44727 7.65672 11.0701C6.79769 12.6929 6.51112 14.558 6.84332 16.3638C7.17553 18.1697 8.1071 19.8107 9.48742 21.0215C9.60254 21.1228 9.69658 21.2457 9.76417 21.3833C9.83176 21.5209 9.87156 21.6704 9.88132 21.8234C9.89107 21.9764 9.87057 22.1298 9.821 22.2749C9.77143 22.42 9.69376 22.5538 9.59242 22.6689ZM14.8751 17.231C14.5406 17.2354 14.2091 17.1679 13.903 17.033C13.597 16.898 13.3235 16.6989 13.1011 16.449C12.8788 16.1991 12.7128 15.9043 12.6143 15.5846C12.5159 15.2649 12.4873 14.9278 12.5306 14.5962C12.5738 14.2645 12.6879 13.946 12.865 13.6622C13.0422 13.3785 13.2782 13.1361 13.5572 12.9516C13.8362 12.7671 14.1517 12.6448 14.4821 12.5928C14.8125 12.5409 15.1503 12.5607 15.4724 12.6507L19.8836 8.23953C19.9912 8.1281 20.1199 8.03922 20.2623 7.97808C20.4046 7.91693 20.5577 7.88475 20.7126 7.8834C20.8675 7.88206 21.0212 7.91157 21.1645 7.97023C21.3079 8.0289 21.4382 8.11552 21.5477 8.22507C21.6573 8.33461 21.7439 8.46487 21.8025 8.60825C21.8612 8.75163 21.8907 8.90525 21.8894 9.06016C21.888 9.21507 21.8558 9.36816 21.7947 9.5105C21.7336 9.65284 21.6447 9.78157 21.5333 9.88919L17.1221 14.3004C17.2194 14.6454 17.2348 15.0084 17.1672 15.3605C17.0996 15.7126 16.9509 16.0441 16.7327 16.3286C16.5146 16.6131 16.2331 16.8428 15.9106 16.9994C15.5881 17.1561 15.2336 17.2354 14.8751 17.231ZM21.8051 22.7739C21.5718 22.9697 21.2712 23.0665 20.9675 23.0437C20.6638 23.0209 20.3811 22.8802 20.1797 22.6517C19.9784 22.4232 19.8743 22.125 19.8898 21.8209C19.9053 21.5167 20.0392 21.2307 20.2628 21.0239C21.3972 20.029 22.2334 18.7389 22.6785 17.2972C23.1236 15.8554 23.1601 14.3184 22.7839 12.8572C22.7066 12.5574 22.7515 12.2391 22.9088 11.9724C23.0661 11.7057 23.3229 11.5124 23.6228 11.435C23.9226 11.3577 24.2409 11.4026 24.5076 11.5599C24.7743 11.7172 24.9676 11.974 25.0449 12.2739C25.264 13.1313 25.3749 14.0127 25.3751 14.8977C25.3734 16.3887 25.0541 17.8623 24.4385 19.2204C23.823 20.5784 22.9253 21.7898 21.8051 22.7739Z"
                  fill="#FBF3E4"
                />
              </svg>
            </span>
            <span className="user_nav_link_text">Dashboard</span>
          </NavLink>
        </Nav.Item> */}
        <Nav.Item>
          <NavLink to="/user/profile" className="nav-link">
            <span className="user_nav_link_icon">
              <svg
                width="29"
                height="29"
                viewBox="0 0 29 29"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clipPath="url(#clip0_2479_3625)">
                  <path
                    d="M14.875 14.731C18.741 14.731 21.875 11.597 21.875 7.73096C21.875 3.86496 18.741 0.730957 14.875 0.730957C11.009 0.730957 7.875 3.86496 7.875 7.73096C7.875 11.597 11.009 14.731 14.875 14.731Z"
                    fill="#14183E"
                  />
                  <path
                    d="M14.875 17.064C9.07867 17.0704 4.38145 21.7676 4.375 27.564C4.375 28.2083 4.89732 28.7306 5.54165 28.7306H24.2083C24.8526 28.7306 25.3749 28.2083 25.3749 27.564C25.3685 21.7676 20.6713 17.0704 14.875 17.064Z"
                    fill="#14183E"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_2479_3625">
                    <rect
                      width="28"
                      height="28"
                      fill="white"
                      transform="translate(0.875 0.730957)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </span>
            <span className="user_nav_link_text">Profile</span>
          </NavLink>
        </Nav.Item>

        <Nav.Item>
          <NavLink to="/user/upcoming-session" className="nav-link">
            <span className="user_nav_link_icon">
              <svg
                width="28"
                height="24"
                viewBox="0 0 28 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M20.6095 21.748H7.39116C6.80245 21.748 6.3252 22.2253 6.3252 22.814C6.3252 23.4027 6.80245 23.88 7.39116 23.88H20.6095C21.1982 23.88 21.6755 23.4027 21.6755 22.814C21.6755 22.2254 21.1982 21.748 20.6095 21.748Z"
                  fill="#14183E"
                />
                <path
                  d="M15.2354 5.71484H10.4058C9.8171 5.71484 9.33984 6.1921 9.33984 6.78081V10.1184C9.33984 10.7072 9.8171 11.1844 10.4058 11.1844H15.2354C15.8241 11.1844 16.3014 10.7072 16.3014 10.1184V9.42342L17.6062 10.1767C18.0737 10.4466 18.6604 10.1089 18.6604 9.56812V7.33113C18.6604 6.79131 18.0745 6.45203 17.6062 6.72252L16.3014 7.47584V6.78087C16.3014 6.1921 15.8241 5.71484 15.2354 5.71484Z"
                  fill="#14183E"
                />
                <path
                  d="M27.2893 13.9355H0.710664C0.318172 13.9355 0 14.2537 0 14.6462V16.5429C0 18.3091 1.43177 19.7409 3.19796 19.7409H24.802C26.5682 19.7409 28 18.3091 28 16.5429V14.6462C28 14.2537 27.6818 13.9355 27.2893 13.9355Z"
                  fill="#14183E"
                />
                <path
                  d="M24.802 0.121094H3.19796C1.43177 0.121094 0 1.55287 0 3.31905V11.0929C0 11.4854 0.318172 11.8036 0.710664 11.8036H2.13199C2.52448 11.8036 2.84266 11.4854 2.84266 11.0929V4.02972C2.84266 3.44101 3.31991 2.96375 3.90863 2.96375H24.0914C24.6801 2.96375 25.1573 3.44101 25.1573 4.02972V11.093C25.1573 11.4855 25.4755 11.8037 25.868 11.8037H27.2893C27.6818 11.8037 28 11.4855 28 11.093V3.31905C28 1.55287 26.5682 0.121094 24.802 0.121094Z"
                  fill="#14183E"
                />
              </svg>
            </span>
            <span className="user_nav_link_text">Sessions</span>
          </NavLink>
        </Nav.Item>

        <Nav.Item>
          <NavLink to="/user/my-programs" className="nav-link">
            <span className="user_nav_link_icon">
              <svg
                width="22"
                height="22"
                viewBox="0 0 22 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4 4.04025V2.20975C3.99988 1.98519 4.04402 1.7628 4.1299 1.55531C4.21578 1.34782 4.34171 1.15929 4.5005 1.0005C4.65929 0.841713 4.84782 0.715779 5.05531 0.629899C5.2628 0.544019 5.48519 0.499878 5.70975 0.5H5.79025C6.01481 0.499878 6.2372 0.544019 6.44469 0.629899C6.65218 0.715779 6.84071 0.841713 6.9995 1.0005C7.15829 1.15929 7.28422 1.34782 7.3701 1.55531C7.45598 1.7628 7.50012 1.98519 7.5 2.20975V4.04025C7.49995 4.49369 7.31981 4.92854 6.99918 5.24918C6.67854 5.56981 6.24369 5.74995 5.79025 5.75H5.70975C5.25631 5.74995 4.82146 5.56981 4.50082 5.24918C4.18019 4.92854 4.00005 4.49369 4 4.04025ZM19.75 4V4.04025C19.749 4.95754 19.3842 5.83699 18.7356 6.48561C18.087 7.13423 17.2075 7.49905 16.2902 7.5H16.2099C15.2926 7.49909 14.4131 7.1343 13.7645 6.48567C13.1158 5.83704 12.751 4.95757 12.75 4.04025V4H9.25V4.04025C9.24905 4.95754 8.88423 5.83699 8.23561 6.48561C7.58699 7.13423 6.70754 7.49905 5.79025 7.5H5.70992C4.7926 7.49909 3.91311 7.1343 3.26445 6.48567C2.61579 5.83704 2.25095 4.95757 2.25 4.04025V4C1.78587 4 1.34075 4.18438 1.01256 4.51256C0.684374 4.84075 0.5 5.28587 0.5 5.75V19.75C0.5 20.2141 0.684374 20.6592 1.01256 20.9874C1.34075 21.3156 1.78587 21.5 2.25 21.5H19.75C20.2141 21.5 20.6592 21.3156 20.9874 20.9874C21.3156 20.6592 21.5 20.2141 21.5 19.75V5.75C21.5 5.28587 21.3156 4.84075 20.9874 4.51256C20.6592 4.18438 20.2141 4 19.75 4ZM7.5 18H4V16.25H7.5V18ZM7.50175 14.5018H4V12.75H7.50175V14.5018ZM7.50175 11H4V9.25H7.50175V11ZM12.75 18H9.25V16.25H12.75V18ZM12.75 14.5018H9.25V12.75H12.75V14.5018ZM12.75 11H9.25V9.25H12.75V11ZM18 18H14.5V16.25H18V18ZM18.0018 14.5018H14.5V12.75H18.0018V14.5018ZM18.0018 11H14.5V9.25H18.0018V11ZM14.5 4.04025V2.20975C14.4999 1.98519 14.544 1.7628 14.6299 1.55531C14.7158 1.34782 14.8417 1.15929 15.0005 1.0005C15.1593 0.841713 15.3478 0.715779 15.5553 0.629899C15.7628 0.544019 15.9852 0.499878 16.2098 0.5H16.2902C16.5148 0.499878 16.7372 0.544019 16.9447 0.629899C17.1522 0.715779 17.3407 0.841713 17.4995 1.0005C17.6583 1.15929 17.7842 1.34782 17.8701 1.55531C17.956 1.7628 18.0001 1.98519 18 2.20975V4.04025C18 4.49369 17.8198 4.92854 17.4992 5.24918C17.1785 5.56981 16.7437 5.74995 16.2902 5.75H16.2098C15.7563 5.74995 15.3215 5.56981 15.0008 5.24918C14.6802 4.92854 14.5 4.49369 14.5 4.04025Z"
                  fill="#14183E"
                />
              </svg>
            </span>
            <span className="user_nav_link_text">Schedules</span>
          </NavLink>
        </Nav.Item>

        <Nav.Item>
          <NavLink to="/user/messages" className="nav-link">
            <span className="user_nav_link_icon">
              <svg
                width="29"
                height="29"
                viewBox="0 0 29 29"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clipPath="url(#clip0_2382_4586)">
                  <path
                    d="M28.8213 7.19653L19.0003 17.0175C17.9053 18.1098 16.4217 18.7232 14.875 18.7232C13.3283 18.7232 11.8447 18.1098 10.7497 17.0175L0.928667 7.19653C0.912333 7.38087 0.875 7.5477 0.875 7.73087V21.7309C0.876853 23.2774 1.49203 24.7601 2.58559 25.8536C3.67915 26.9472 5.16181 27.5623 6.70833 27.5642H23.0417C24.5882 27.5623 26.0709 26.9472 27.1644 25.8536C28.258 24.7601 28.8731 23.2774 28.875 21.7309V7.73087C28.875 7.5477 28.8377 7.38087 28.8213 7.19653Z"
                    fill="#14183E"
                  />
                  <path
                    d="M17.3508 15.368L28.0072 4.71054C27.4909 3.85458 26.7629 3.14608 25.8931 2.65339C25.0234 2.1607 24.0414 1.90044 23.0418 1.89771H6.7085C5.70892 1.90044 4.72692 2.1607 3.8572 2.65339C2.98747 3.14608 2.25939 3.85458 1.74316 4.71054L12.3995 15.368C13.057 16.0229 13.9472 16.3906 14.8752 16.3906C15.8031 16.3906 16.6933 16.0229 17.3508 15.368Z"
                    fill="#14183E"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_2382_4586">
                    <rect
                      width="28"
                      height="28"
                      fill="white"
                      transform="translate(0.875 0.730957)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </span>
            <span className="user_nav_link_text">
              {count > 0 ? `Messages (${count})` : "Messages"}
            </span>
          </NavLink>
        </Nav.Item>

        <Nav.Item>
          <NavLink to="/user/my-coach" className="nav-link">
            <span className="user_nav_link_icon">
              <svg
                width="28"
                height="28"
                viewBox="0 0 28 28"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clipPath="url(#clip0_10052_9734)">
                  <path
                    d="M23.0295 16.2695C20.2885 16.2695 18.0586 18.4995 18.0586 21.2404C18.0586 23.9814 20.2886 26.2114 23.0295 26.2114C25.7704 26.2114 28.0004 23.9814 28.0004 21.2404C28.0004 18.4995 25.7705 16.2695 23.0295 16.2695ZM26.0574 20.208L22.809 23.4564C22.6456 23.6197 22.4315 23.7014 22.2174 23.7014C22.0032 23.7014 21.7891 23.6197 21.6257 23.4564L20.0015 21.8322C19.6748 21.5054 19.6748 20.9756 20.0015 20.6489C20.3284 20.3222 20.858 20.3222 21.1848 20.6489L22.2174 21.6815L24.8741 19.0247C25.2009 18.698 25.7305 18.698 26.0574 19.0247C26.3842 19.3514 26.3842 19.8812 26.0574 20.208Z"
                    fill="#14183E"
                  />
                  <path
                    d="M12.6513 9.5987C14.7076 9.5987 16.3804 7.92583 16.3804 5.86966C16.3805 3.81342 14.7076 2.14062 12.6513 2.14062C10.5951 2.14062 8.9223 3.81342 8.9223 5.86966C8.9223 7.9259 10.5952 9.5987 12.6513 9.5987Z"
                    fill="#14183E"
                  />
                  <path
                    d="M19.9157 15.1829V14.525C19.9157 13.1059 19.0037 11.8476 17.6552 11.4058L17.649 11.4038L15.6765 11.0772C15.5087 11.0256 15.3293 11.1144 15.2689 11.28L13.0309 17.4205C12.9018 17.7747 12.4008 17.7747 12.2717 17.4205L10.0337 11.28C9.98489 11.1463 9.85871 11.0625 9.72347 11.0625C9.69138 11.0625 7.65372 11.4033 7.65372 11.4033C6.29414 11.8564 5.38574 13.1168 5.38574 14.542V19.6513C5.38574 20.417 6.00644 21.0377 6.77212 21.0377H16.0906C16.0617 20.8124 16.0452 20.5834 16.0452 20.3503C16.0453 17.9067 17.6816 15.8393 19.9157 15.1829Z"
                    fill="#14183E"
                  />
                  <path
                    d="M13.4773 10.7032C13.3899 10.6081 13.2622 10.5601 13.1331 10.5601H12.1697C12.0405 10.5601 11.9128 10.608 11.8255 10.7032C11.6902 10.8505 11.6706 11.0633 11.7667 11.2297L12.2816 12.0061L12.0405 14.0399L12.5153 15.3028C12.5616 15.4298 12.7412 15.4298 12.7875 15.3028L13.2622 14.0399L13.0211 12.0061L13.5361 11.2297C13.6322 11.0633 13.6125 10.8505 13.4773 10.7032Z"
                    fill="#14183E"
                  />
                  <path
                    d="M4.04327 8.76757C5.18755 8.76757 6.11846 7.83662 6.11846 6.69238C6.1185 5.54809 5.18755 4.61719 4.04327 4.61719C2.89898 4.61719 1.96808 5.54809 1.96808 6.69238C1.96808 7.83667 2.89902 8.76757 4.04327 8.76757Z"
                    fill="#14183E"
                  />
                  <path
                    d="M8.08582 11.8751V11.509C8.08582 10.7193 7.57833 10.0191 6.82791 9.77323L6.82442 9.77209L5.72677 9.59035C5.63336 9.56161 5.53352 9.61106 5.49994 9.70322L4.25451 13.1204C4.18265 13.3175 3.90384 13.3175 3.83198 13.1204L2.58655 9.70322C2.5594 9.6288 2.48919 9.58215 2.41392 9.58215C2.39607 9.58215 1.26212 9.77184 1.26212 9.77184C0.505519 10.024 0 10.7253 0 11.5185V14.3618C0 14.7879 0.345417 15.1333 0.771515 15.1333H5.95718C5.94113 15.0079 5.93192 14.8805 5.93192 14.7508C5.93197 13.3909 6.84257 12.2404 8.08582 11.8751Z"
                    fill="#14183E"
                  />
                  <path
                    d="M4.5029 9.38222C4.45428 9.32927 4.38322 9.30259 4.31136 9.30259H3.77521C3.70331 9.30259 3.63225 9.32923 3.58368 9.38222C3.50842 9.4642 3.49749 9.58262 3.55094 9.67519L3.83753 10.1073L3.70335 11.2391L3.96754 11.9419C3.9933 12.0126 4.09327 12.0126 4.11903 11.9419L4.38322 11.2391L4.24905 10.1073L4.53563 9.67519C4.58908 9.58262 4.57816 9.4642 4.5029 9.38222Z"
                    fill="#14183E"
                  />
                  <path
                    d="M21.2731 8.76757C20.1289 8.76757 19.1979 7.83662 19.1979 6.69238C19.1979 5.54809 20.1289 4.61719 21.2731 4.61719C22.4174 4.61719 23.3483 5.54809 23.3483 6.69238C23.3483 7.83667 22.4174 8.76757 21.2731 8.76757Z"
                    fill="#14183E"
                  />
                  <path
                    d="M17.2306 11.8751V11.509C17.2306 10.7193 17.7381 10.0191 18.4885 9.77323L18.492 9.77209L19.5896 9.59035C19.683 9.56161 19.7829 9.61106 19.8165 9.70322L21.0619 13.1204C21.1338 13.3175 21.4126 13.3175 21.4844 13.1204L22.7299 9.70322C22.757 9.6288 22.8272 9.58215 22.9025 9.58215C22.9203 9.58215 24.0543 9.77184 24.0543 9.77184C24.8109 10.024 25.3164 10.7253 25.3164 11.5185V14.3618C25.3164 14.7879 24.971 15.1333 24.5449 15.1333H19.3592C19.3753 15.0079 19.3845 14.8805 19.3845 14.7508C19.3844 13.3909 18.4738 12.2404 17.2306 11.8751Z"
                    fill="#14183E"
                  />
                  <path
                    d="M20.8135 9.38222C20.8621 9.32927 20.9332 9.30259 21.005 9.30259H21.5412C21.6131 9.30259 21.6842 9.32923 21.7327 9.38222C21.808 9.4642 21.8189 9.58262 21.7655 9.67519L21.4789 10.1073L21.6131 11.2391L21.3489 11.9419C21.3231 12.0126 21.2231 12.0126 21.1974 11.9419L20.9332 11.2391L21.0674 10.1073L20.7808 9.67519C20.7273 9.58262 20.7382 9.4642 20.8135 9.38222Z"
                    fill="#14183E"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_10052_9734">
                    <rect width="28" height="28" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </span>
            <span className="user_nav_link_text">Coaches</span>
          </NavLink>
        </Nav.Item>

        <Nav.Item>
          <NavLink to="/user/activities" className="nav-link">
            <span className="user_nav_link_icon">
              <svg
                width="28"
                height="28"
                viewBox="0 0 28 28"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1.58553 7.42007C2.0231 6.59863 2.5409 5.82251 3.13136 5.10307L4.90003 6.6279C4.43053 7.20317 4.01647 7.82154 3.66336 8.47474L1.58553 7.42007ZM0.535526 9.9774C0.267679 10.8705 0.0902327 11.7882 0.00585938 12.7167L2.32753 12.9501C2.39714 12.1815 2.54291 11.4218 2.76269 10.6821L0.535526 9.9774ZM7.40136 1.62524C6.59842 2.05139 5.83884 2.55465 5.13336 3.1279L6.58119 4.9514C7.17803 4.46654 7.82126 4.04176 8.50153 3.68324L7.40136 1.62524ZM12.6735 0.064237C11.7579 0.147398 10.8528 0.321307 9.97153 0.583404L10.633 2.8199C11.3675 2.60273 12.1218 2.45892 12.8847 2.39057L12.6735 0.064237ZM1.58553 20.5801C2.0231 21.4015 2.5409 22.1776 3.13136 22.8971L4.90003 21.3722C4.43053 20.797 4.01647 20.1786 3.66336 19.5254L1.58553 20.5801ZM2.76269 17.3297C2.54489 16.5898 2.40107 15.8301 2.33336 15.0617L0.0116927 15.2951C0.0960715 16.2216 0.273123 17.1374 0.540193 18.0286L2.76269 17.3297ZM8.50153 24.3169C7.82126 23.9584 7.17803 23.5336 6.58119 23.0487L5.13336 24.8722C5.84032 25.4457 6.60147 25.949 7.40603 26.3749L8.50153 24.3169ZM12.8847 25.6131C12.1218 25.5447 11.3675 25.4009 10.633 25.1837L9.97153 27.4167C10.8529 27.6776 11.758 27.8504 12.6735 27.9324L12.8847 25.6131ZM24.2189 19.5872C23.8669 20.2408 23.4532 20.8593 22.9834 21.4341L24.7532 22.9589C25.3442 22.2398 25.862 21.4637 26.299 20.6419L24.2189 19.5872ZM27.3502 18.0834C27.6173 17.1922 27.7943 16.2764 27.8787 15.3499L25.557 15.1166C25.4875 15.8855 25.3417 16.6456 25.1219 17.3857L27.3502 18.0834ZM20.4832 26.4367C21.2878 26.0108 22.0489 25.5076 22.7559 24.9341L21.3034 23.1117C20.7064 23.5974 20.0632 24.0234 19.383 24.3834L20.4832 26.4367ZM15.211 28.0001C16.1265 27.9175 17.0315 27.7448 17.913 27.4844L17.2515 25.2467C16.517 25.4643 15.7628 25.6085 14.9999 25.6772L15.211 28.0001ZM23.1934 12.8334C23.4304 14.7146 23.0888 16.6234 22.2141 18.3057C21.3394 19.988 19.973 21.364 18.2969 22.2505C16.6208 23.137 14.7144 23.492 12.8315 23.2682C10.9487 23.0443 9.17866 22.2524 7.75707 20.9977C6.33548 19.7429 5.32976 18.085 4.87379 16.2445C4.41781 14.4041 4.53322 12.4684 5.20463 10.6951C5.87605 8.92186 7.07163 7.39516 8.63223 6.31824C10.1928 5.24131 12.0444 4.66525 13.9405 4.66674C14.3272 4.66895 14.7133 4.69545 15.0967 4.74607H15.1072V0.0595703C18.4016 0.338976 21.4911 1.77446 23.8292 4.11213C26.1673 6.4498 27.6034 9.53902 27.8834 12.8334H23.1934ZM19.7739 12.8334H15.9507C15.7474 12.4839 15.4567 12.1932 15.1072 11.9899V7.00007H12.7739V11.9899C12.4644 12.1681 12.2002 12.4151 12.0015 12.7118C11.8029 13.0085 11.6752 13.347 11.6284 13.7009C11.5816 14.0549 11.6169 14.4149 11.7316 14.7531C11.8463 15.0912 12.0372 15.3984 12.2897 15.6509C12.5422 15.9034 12.8494 16.0943 13.1875 16.209C13.5257 16.3237 13.8857 16.359 14.2397 16.3122C14.5936 16.2654 14.9321 16.1377 15.2288 15.9391C15.5255 15.7404 15.7725 15.4762 15.9507 15.1667H19.7739V12.8334Z"
                  fill="white"
                />
              </svg>
            </span>
            <span className="user_nav_link_text">Activities</span>
          </NavLink>
        </Nav.Item>

        {/* <Nav.Item>
          <NavLink to="/user/my-coach" className="nav-link">
            <span className="user_nav_link_icon">
              <svg width="29" height="28" viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_7271_4409)">
                  <path d="M8.9667 9.53715C11.3607 9.53715 13.3084 7.5895 13.3084 5.19546C13.3084 2.80141 11.3607 0.85376 8.9667 0.85376C6.57265 0.85376 4.625 2.80141 4.625 5.19546C4.625 7.5895 6.57265 9.53715 8.9667 9.53715Z" fill="black" />
                  <path d="M28.488 20.1408C28.4653 20.0709 28.3887 19.9053 28.1696 19.8787L25.541 19.5575C24.8898 19.4779 24.3357 19.0753 24.0588 18.4807L22.9412 16.0799C22.8479 15.8796 22.6669 15.8582 22.5932 15.8582C22.5197 15.8582 22.3387 15.8798 22.2455 16.0799L21.1278 18.4806C20.8511 19.0752 20.297 19.4779 19.6459 19.5575L17.017 19.8787C16.7979 19.9054 16.7214 20.0709 16.6986 20.1408C16.676 20.2108 16.6405 20.3896 16.802 20.5401L18.7399 22.3451C19.2201 22.7922 19.4317 23.4436 19.306 24.0876L18.7991 26.6867C18.7569 26.9034 18.8906 27.0273 18.9501 27.0705C19.0097 27.1137 19.169 27.2026 19.3619 27.0956L21.6773 25.8102C21.9641 25.651 22.2787 25.5714 22.5932 25.5714C22.9079 25.5714 23.2225 25.651 23.5094 25.8102L25.8248 27.0956C26.018 27.2028 26.1769 27.1138 26.2365 27.0705C26.296 27.0273 26.4299 26.9034 26.3875 26.6867L25.8806 24.0874C25.755 23.4434 25.9667 22.792 26.4467 22.345L28.3848 20.5402C28.5462 20.3897 28.5108 20.2108 28.488 20.1408Z" fill="black" />
                  <path d="M15.2683 19.6762C15.4977 18.9703 16.0978 18.4759 16.8345 18.3861L17.4248 18.314V15.2728C17.4248 13.6206 16.3631 12.1556 14.793 11.6412L14.7857 11.6388L12.4893 11.2586C12.2938 11.1985 12.085 11.302 12.0147 11.4948L9.40908 18.6441C9.25871 19.0566 8.67542 19.0566 8.52515 18.6441L5.91945 11.4948C5.86269 11.339 5.71572 11.2415 5.55828 11.2415C5.52094 11.2415 3.14849 11.6384 3.14849 11.6384C1.5655 12.1657 0.507812 13.6331 0.507812 15.2926V21.2414C0.507812 22.1329 1.23053 22.8556 2.12201 22.8556H15.8107C16.1632 22.8556 16.4888 22.7424 16.754 22.5504L15.7771 21.6406C15.2339 21.1347 15.039 20.382 15.2683 19.6762Z" fill="black" />
                  <path d="M9.90858 11.0838C9.80893 10.9752 9.66336 10.9207 9.51611 10.9207H8.41741C8.27006 10.9207 8.1245 10.9752 8.02494 11.0838C7.8707 11.2518 7.84836 11.4944 7.95782 11.6841L8.54506 12.5694L8.27015 14.8887L8.81158 16.329C8.86437 16.4738 9.06924 16.4738 9.12203 16.329L9.66346 14.8887L9.38855 12.5694L9.9758 11.6841C10.0852 11.4945 10.0628 11.2518 9.90858 11.0838Z" fill="black" />
                </g>
                <defs>
                  <clipPath id="clip0_7271_4409">
                    <rect width="28" height="28" fill="white" transform="translate(0.507812)" />
                  </clipPath>
                </defs>
              </svg>
            </span>
            <span className="user_nav_link_text">My Coach</span>
          </NavLink>
        </Nav.Item> */}
        <Nav.Item>
          <NavLink to="/user/payment-history" className="nav-link">
            <span className="user_nav_link_icon">
              <svg
                width="28"
                height="28"
                viewBox="0 0 28 28"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clipPath="url(#clip0_10052_9889)">
                  <path
                    d="M27 3.61914H23.1906H10.8096H7.00002C6.44773 3.61914 6 4.06687 6 4.61916V8.09527H7.00002H8.00004H8.55801H10.3187C11.0059 7.43885 11.4998 6.58228 11.7043 5.61918H22.2959C22.689 7.46991 24.1493 8.93024 26.0001 9.32339V14.2006C24.1493 14.5936 22.6889 16.054 22.2959 17.9048H21.3335V19.9048H23.1906H27C27.5523 19.9048 28.0001 19.4572 28.0001 18.9048V15.0953V8.42853V4.61916C28.0001 4.06681 27.5523 3.61914 27 3.61914Z"
                    fill="#14183E"
                  />
                  <path
                    d="M18.3335 10.0957H7.99998H5.99994H1.00002C0.447727 10.0957 0 10.5434 0 11.0957V14.0957H19.3335V11.0957C19.3335 10.5434 18.8858 10.0957 18.3335 10.0957Z"
                    fill="#14183E"
                  />
                  <path
                    d="M0 16.0957V23.3814C0 23.9337 0.447727 24.3814 1.00002 24.3814H18.3335C18.8858 24.3814 19.3335 23.9337 19.3335 23.3814V19.9052V17.9053V16.0957H0ZM8.33346 20.0957H5.00003C4.44774 20.0957 4.00002 19.648 4.00002 19.0957C4.00002 18.5434 4.44774 18.0957 5.00003 18.0957H8.33346C8.88575 18.0957 9.33348 18.5434 9.33348 19.0957C9.33342 19.648 8.8857 20.0957 8.33346 20.0957Z"
                    fill="#14183E"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_10052_9889">
                    <rect width="28" height="28" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </span>
            <span className="user_nav_link_text">Payments</span>
          </NavLink>
        </Nav.Item>
        <Nav.Item>
          <NavLink to="/user/setting" className="nav-link">
            <span className="user_nav_link_icon">
              <svg
                width="26"
                height="29"
                viewBox="0 0 26 29"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.749868 21.731C1.71488 23.4058 3.85497 23.9812 5.52983 23.0162C5.53098 23.0156 5.53207 23.0149 5.53322 23.0143L6.05237 22.7144C7.03237 23.5529 8.15882 24.2031 9.37502 24.6324V25.231C9.37502 27.1639 10.942 28.731 12.875 28.731C14.808 28.731 16.375 27.1639 16.375 25.231V24.6325C17.5914 24.2024 18.7179 23.5514 19.6977 22.7121L20.2192 23.0131C21.8944 23.9796 24.036 23.4051 25.0025 21.7298C25.969 20.0545 25.3945 17.9129 23.7192 16.9464L23.2012 16.6478C23.4344 15.3789 23.4344 14.0783 23.2012 12.8094L23.7192 12.5108C25.3944 11.5443 25.969 9.4027 25.0025 7.7274C24.036 6.05216 21.8945 5.47756 20.2192 6.44405L19.7 6.7439C18.719 5.90647 17.5918 5.25744 16.375 4.82946V4.23096C16.375 2.29797 14.808 0.730957 12.875 0.730957C10.942 0.730957 9.37502 2.29797 9.37502 4.23096V4.82946C8.15866 5.25946 7.03215 5.91046 6.05237 6.74981L5.53087 6.44766C3.85557 5.48111 1.71401 6.05572 0.747517 7.73096C-0.218976 9.4062 0.355571 11.5478 2.03087 12.5143L2.54887 12.813C2.31568 14.0818 2.31568 15.3824 2.54887 16.6513L2.03087 16.95C0.36022 17.919 -0.212468 20.0564 0.749868 21.731ZM12.875 10.0643C15.4523 10.0643 17.5417 12.1536 17.5417 14.731C17.5417 17.3083 15.4523 19.3976 12.875 19.3976C10.2977 19.3976 8.20837 17.3083 8.20837 14.731C8.20837 12.1536 10.2977 10.0643 12.875 10.0643Z"
                  fill="#14183E"
                />
              </svg>
            </span>
            <span className="user_nav_link_text">Settings</span>
          </NavLink>
        </Nav.Item>

        {/*  <Nav.Item>
          <NavLink to="/user/upcoming-session" className="nav-link">
            <VscDebugBreakpointUnsupported className=" -m-4 text-[#14183e] text-[3.5rem]" />
            <span className="ml-2 user_nav_link_text">Support</span>
          </NavLink>
        </Nav.Item> */}
      </Nav>
      <NavLink className="logout_link" onClick={onClickLogOutConfirmationPopup}>
        <span className="user_nav_link_icon">
          <svg
            width="17"
            height="17"
            viewBox="0 0 17 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_2479_4402)">
              <path
                d="M8.15848 10.731C7.98167 10.731 7.8121 10.8012 7.68707 10.9262C7.56205 11.0512 7.49181 11.2208 7.49181 11.3976V13.3976C7.49181 13.9281 7.2811 14.4368 6.90603 14.8118C6.53095 15.1869 6.02225 15.3976 5.49181 15.3976H3.84115C3.31071 15.3976 2.80201 15.1869 2.42693 14.8118C2.05186 14.4368 1.84115 13.9281 1.84115 13.3976V4.06429C1.84115 3.53386 2.05186 3.02515 2.42693 2.65008C2.80201 2.275 3.31071 2.06429 3.84115 2.06429H5.49181C6.02225 2.06429 6.53095 2.275 6.90603 2.65008C7.2811 3.02515 7.49181 3.53386 7.49181 4.06429V6.06429C7.49181 6.2411 7.56205 6.41067 7.68707 6.5357C7.8121 6.66072 7.98167 6.73096 8.15848 6.73096C8.33529 6.73096 8.50486 6.66072 8.62988 6.5357C8.75491 6.41067 8.82515 6.2411 8.82515 6.06429V4.06429C8.82409 3.18056 8.47256 2.33333 7.84767 1.70844C7.22277 1.08355 6.37554 0.732016 5.49181 0.730957H3.84115C2.95742 0.732016 2.11018 1.08355 1.48529 1.70844C0.8604 2.33333 0.508871 3.18056 0.507813 4.06429L0.507812 13.3976C0.508871 14.2814 0.8604 15.1286 1.48529 15.7535C2.11018 16.3784 2.95742 16.7299 3.84115 16.731H5.49181C6.37554 16.7299 7.22277 16.3784 7.84767 15.7535C8.47256 15.1286 8.82409 14.2814 8.82515 13.3976V11.3976C8.82515 11.2208 8.75491 11.0512 8.62988 10.9262C8.50486 10.8012 8.33529 10.731 8.15848 10.731Z"
                fill="#00504E"
              />
              <path
                d="M15.7522 7.31701L12.6948 4.25968C12.6333 4.196 12.5598 4.14522 12.4784 4.11028C12.3971 4.07534 12.3096 4.05695 12.2211 4.05618C12.1326 4.05541 12.0448 4.07228 11.9629 4.1058C11.8809 4.13932 11.8065 4.18882 11.7439 4.25141C11.6813 4.31401 11.6318 4.38844 11.5983 4.47038C11.5648 4.55231 11.5479 4.64009 11.5487 4.72861C11.5494 4.81713 11.5678 4.90461 11.6028 4.98595C11.6377 5.06728 11.6885 5.14085 11.7522 5.20234L14.5935 8.04434L4.50749 8.06434C4.33068 8.06434 4.16111 8.13458 4.03608 8.25961C3.91106 8.38463 3.84082 8.5542 3.84082 8.73101C3.84082 8.90782 3.91106 9.07739 4.03608 9.20242C4.16111 9.32744 4.33068 9.39768 4.50749 9.39768L14.6328 9.37701L11.7508 12.2597C11.6871 12.3212 11.6364 12.3947 11.6014 12.4761C11.5665 12.5574 11.5481 12.6449 11.5473 12.7334C11.5466 12.8219 11.5634 12.9097 11.5969 12.9916C11.6305 13.0736 11.68 13.148 11.7426 13.2106C11.8052 13.2732 11.8796 13.3227 11.9615 13.3562C12.0434 13.3897 12.1312 13.4066 12.2198 13.4058C12.3083 13.4051 12.3958 13.3867 12.4771 13.3517C12.5584 13.3168 12.632 13.266 12.6935 13.2023L15.7508 10.145C16.1259 9.77013 16.3368 9.26162 16.3371 8.73129C16.3373 8.20096 16.1269 7.69224 15.7522 7.31701Z"
                fill="#00504E"
              />
            </g>
            <defs>
              <clipPath id="clip0_2479_4402">
                <rect
                  width="16"
                  height="16"
                  fill="white"
                  transform="translate(0.507812 0.730957)"
                />
              </clipPath>
            </defs>
          </svg>
        </span>

        <span className="user_nav_link_text ms-2">Logout</span>
      </NavLink>
      {console.log(visible)}
      {visible === true ? (
        <Modal
          visible={visible}
          onClickAway={() => setVisible(false)}
          height="200px"
          width="400px"
        >
          <div className="text-center logout_modal position-absolute start-50 top-50 translate-middle">
            <h3>
              {" "}
              Are you sure <br />
              You want to Logout?
            </h3>
            <div className="mt-4 logout_button_container">
              <button
                className="p-2 rounded btn-success me-3"
                onClick={() => {
                  // delete_conversation();
                  // setVisible(false);
                  onClickLogOut();
                }}
              >
                {" "}
                <h5 className="px-4 m-0 fs-14 fw-400">Yes</h5>{" "}
              </button>
              <button
                className="p-2 text-white border-0 rounded btn-success bg-secondary"
                onClick={() => setVisible(false)}
              >
                {" "}
                <h5 className="px-4 m-0 fs-14 fw-400">No</h5>{" "}
              </button>
            </div>
          </div>
        </Modal>
      ) : (
        ""
      )}
    </>
  );
}

export default UserSideMenuComponent;
